
<div class="grid-container">
    <app-alert class="grid-1"></app-alert>
    <div class="margin-container grid-2">
        <app-header></app-header>
        <fluent-divider style="margin-top: 10px;"></fluent-divider>
    </div>
    <div class="margin-container grid-3 scrollable"><router-outlet></router-outlet></div>
   <app-statusbar/>
</div>
